import PaginationHelpers from "./PaginationHelpers";
import dayjs from "dayjs";

export default {

    mixins: [
        PaginationHelpers
    ],

    data() {
        return {
            loaded: false,
            rows: [],
            meta: {},
            links: {},
            constraints: {},
        };
    },

    methods: {
        setData(data) {
            this.rows = data.data;
            this.meta = data.meta;
            this.links = data.links;
            this.constraints = data.constraints;
            this.loaded = true;
        },
        onSort() {
            return this.$refs.pagination.onSort(...arguments)
        },
        refresh() {
            this.$router.push({
                name: this.$route.name,
                params: this.$route.params,
                query: _.assign({}, this.$route.query, {t: dayjs().unix()})
            });
        },
    },
};
